<template>
  <v-container class="my-16 mx-auto">
    <h1>当日イベント</h1>

    <h2 class="bg-green pa-1">
      ◆14:30-15:20
    </h2>

    <v-sheet class="ma-10 pa-3">
      <p class="text-h5">プチデポット 川勝徹さんサイン会</p>
      <p>「グノーシア」開発のプチデポット 川勝徹さんのサイン会です。</p>
    </v-sheet>
    <h2 class="bg-green pa-1">◆15:30-16:30</h2>
    <v-sheet class="ma-10 pa-3">
      <p class="text-h5">RS34 トークショー&サイン会</p>
      <p>
        「ラジルギ」「イルベロスウォンプ」開発のRS34さんのトークショーとサイン会です。
      </p>
    </v-sheet>
    <v-divider
      :thickness="2"
      color="green"
      class="border-opacity-50"
    ></v-divider>
    <h2 class="my-6" style="text-align: center;">◆注意事項◆</h2>
    <v-sheet class="ma-4 pa-3">
      <p>
        ※本イベントは、THE
        CAFEでイベント入場の受付がお済みの方のみ参加ができます。
      </p>
      <p>※撮影、録音は禁止です。</p>
      <p>※先着順でのご案内となります。</p>
      <p>※出演者の事情により、やむをえず時間が変更になる可能性がございます。</p>
      <p>※詳細は受付で配布されるパンフレットをご覧ください。</p>
    </v-sheet>

    <!-- <ComingSoon /> -->
  </v-container>
</template>

<script>
  //import ComingSoon from "./ComingSoon.vue";

  export default {
    name: "App",
    components: {
      //     ComingSoon,
    },
  };
</script>
